export const removeWhiteSpaces = (value) => value.replace(/\s+/g, '')
